import React from 'react';
import { HeroSection } from '../components/sections/HeroSection';
import { ProblemSection } from '../components/sections/ProblemSection';
import { SolutionSection } from '../components/sections/SolutionSection';
import { ResultsSection } from '../components/sections/ResultsSection';
import { AudienceSection } from '../components/sections/AudienceSection';
import { BenefitsSection } from '../components/sections/BenefitsSection';
import { PricingSection } from '../components/sections/PricingSection';
import { HowItWorksSection } from '../components/sections/HowItWorksSection';
import { TestimonialSection } from '../components/sections/TestimonialSection';
import { FAQSection } from '../components/sections/FAQSection';
import { FooterSection } from '../components/sections/FooterSection';
import { SocialProofPopup } from '../components/ui/SocialProofPopup';
export function LandingPage() {
  return <main className="min-h-screen bg-background text-gray-700 font-body selection:bg-primary/30 selection:text-white" data-id="element-390">
      <HeroSection data-id="element-391" />
      <ProblemSection data-id="element-392" />
      <SolutionSection data-id="element-393" />
      <AudienceSection data-id="element-394" />
      <ResultsSection data-id="element-395" />
      <BenefitsSection data-id="element-396" />
      <PricingSection data-id="element-397" />
      <HowItWorksSection data-id="element-398" />
      <TestimonialSection data-id="element-399" />
      <FAQSection data-id="element-400" />
      <FooterSection data-id="element-401" />
      <SocialProofPopup data-id="element-402" />
    </main>;
}